
import * as d3 from 'd3'
import React from "react"
import { Tooltip } from './Components/Tooltip'
import { Renderer } from './Components/Renderer'
import styles from './Heatmap.module.scss'

export type InteractionData = {
  xLabel: string;
  yLabel: string;
  xPos: number;
  yPos: number;
  value: number;
};

const MARGIN = { top: 10, right: 10, bottom: 30, left: 30 };

interface IHeatmap {
  width: number;
  height: number;
  data: { x: string; y: string, value: number | null }[];
}

const Heatmap: React.FC<IHeatmap> = ({ width, height, data }) => {
  const [hoveredCell, setHoveredCell] = React.useState<InteractionData | null>(null);

  return(
    <div className={styles.wrapper}>
      <Renderer
        width={width}
        height={height}
        data={data}
        setHoveredCell={setHoveredCell}
      />
      <Tooltip interactionData={hoveredCell} width={width} height={height} />
    </div>
  );
}

export default Heatmap